export default __webpack_public_path__ + "static/media/Punto_08_Piazza_della_Repubblica_SPA_Def.4332a91a.aac";